import React from 'react';
import { Navigate } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';
import { useAuthenticationContext } from '../../../../application/context/AuthenticationContext';
import MDTypography from '../../shared/atoms/MDTypography';
import { LEGAL_TEXTS } from '../../../utils/texts';

interface CGUGuardProps {
  children: React.ReactNode;
}

const CGUGuard: React.FC<CGUGuardProps> = ({ children }) => {
  const { isAuthenticated, isLoading: authLoading, user } = useAuthenticationContext();


  // If user is not authenticated, let the ProtectedRoute handle it
  if (!isAuthenticated) {
    return <>{children}</>;
  }

  // Show loading state while auth is loading or user object is not yet available
  if (authLoading || !user) {
    return (
      <Box 
        sx={{ 
          display: 'flex', 
          flexDirection: 'column',
          justifyContent: 'center', 
          alignItems: 'center', 
          minHeight: '100vh',
          gap: 2
        }}
      >
        <CircularProgress size={40} />
        <MDTypography variant="body2" color="text" opacity={0.7}>
          {LEGAL_TEXTS.acceptance.loading}
        </MDTypography>
      </Box>
    );
  }

  // Use user object directly since it contains CGU data from Firebase
  if (!user.hasCguAccepted()) {
    return <Navigate to="/cgu-acceptance" replace />;
  }

  // User has accepted CGU, allow access to the protected content
  return <>{children}</>;
};

export default CGUGuard;